<template>
  <!-- Top bar (8px padding + 40px buttons + 8px) + 18px gap to the logo's
  white border (26px to the image itself),
  pushed down by the status bar when the page is drawn underneath it. -->
  <div class="splash-header">
    <v-img
      v-if="cover"
      :src="cover"
      :lazy-src="cover"
      alt="Venue cover"
      class="splash-cover"
      :style="maskStyle"
      gradient="to bottom, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 50%"
    >
      <template #placeholder>
        <v-skeleton-loader type="image" height="100%" />
      </template>
    </v-img>
    <div
      v-else
      class="splash-cover"
      :style="{ ...maskStyle, backgroundColor: fill || tipsColorGlobal }"
    />
  </div>
</template>

<script>
// Exported from the design (402 x 219, including a 62px status bar). The
// status bar part is cropped off via the viewBox; the area above the shape
// (under the real status bar) is filled solid by a second mask layer.
const SHAPE_PATH =
  'M355.073 141.985C285.077 200.525 199.63 223.84 123.463 218.159C80.8725 214.982 38.5582 200.804 0 176.057L0 0L402 0L402 181.508L361.776 136.202C359.556 138.169 357.338 140.079 355.073 141.985Z';
const SHAPE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 62 402 157" preserveAspectRatio="none"><path d="${SHAPE_PATH}"/></svg>`;
const MASK_IMAGE = `linear-gradient(#000, #000), url("data:image/svg+xml,${encodeURIComponent(
  SHAPE_SVG
)}")`;

export default {
  name: 'SplashHeader',
  props: {
    cover: {
      type: String,
      default: null,
    },
    fill: {
      type: String,
      default: null,
    },
  },
  computed: {
    maskStyle() {
      return {
        WebkitMaskImage: MASK_IMAGE,
        maskImage: MASK_IMAGE,
      };
    },
  },
};
</script>

<style scoped lang="scss">
$shape-height: 157px;
$status-bar: env(safe-area-inset-top, 0px);

.splash-header {
  height: calc(74px + #{$status-bar});
}

.splash-cover {
  width: 100%;
  height: calc(#{$shape-height} + #{$status-bar});
  -webkit-mask-size: 100% calc(100% - #{$shape-height} + 1px), 100% $shape-height;
  mask-size: 100% calc(100% - #{$shape-height} + 1px), 100% $shape-height;
  -webkit-mask-position: top, bottom;
  mask-position: top, bottom;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
}
</style>
